import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "o-box u-bg-color-5" }
const _hoisted_2 = { class: "o-box__inner" }
const _hoisted_3 = { class: "o-grid -push-1 -grid-no-row-gap -stretch" }
const _hoisted_4 = { class: "o-grid-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "o-title-3 o-title-numeric" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "o-title-numeric__num",
    "data-content": "1"
  }),
  /*#__PURE__*/_createTextVNode(" Critères ")
], -1 /* HOISTED */)
const _hoisted_6 = { class: "o-box__item" }
const _hoisted_7 = { class: "o-form" }
const _hoisted_8 = { class: "o-form-row -col-1/3" }
const _hoisted_9 = { class: "o-form__item" }
const _hoisted_10 = { class: "o-select__wrap" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "session"
}, "Session", -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Session", -1 /* HOISTED */)
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_15 = { class: "o-form__item" }
const _hoisted_16 = { class: "o-select__wrap" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "statut"
}, "Statut", -1 /* HOISTED */)
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<option value=\"\">Statut</option><option value=\"1\">Étudiant(e) résident(e) du Québec</option><option value=\"2\">Étudiant(e) canadien(ne) non-résident(e) du Québec</option><option value=\"3\">Étudiant(e) français(e) ou belge francophone</option><option value=\"4\">Étudiant(e) international(e)</option>", 5)
const _hoisted_23 = [
  _hoisted_18
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_25 = { class: "o-form__item" }
const _hoisted_26 = { class: "o-select__wrap" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "programme"
}, "Programme", -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Programme", -1 /* HOISTED */)
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_31 = { class: "o-form__item" }
const _hoisted_32 = { class: "o-select__wrap" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "activite"
}, "Activité", -1 /* HOISTED */)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Activité", -1 /* HOISTED */)
const _hoisted_35 = ["value"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_37 = { class: "o-form__item" }
const _hoisted_38 = { class: "o-select__wrap" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  class: "o-label sr-only",
  for: "credits"
}, "Crédits", -1 /* HOISTED */)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Crédits", -1 /* HOISTED */)
const _hoisted_41 = ["value"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_43 = { class: "o-form__item" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__icos" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-right" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-arrow-full-right",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-full-right" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__text__elm" }, " Calculer ", -1 /* HOISTED */)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 0,
  class: ""
}
const _hoisted_48 = { class: "o-form__item o-form__error" }
const _hoisted_49 = { class: "o-form__error__message" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h2", { class: "o-title-3 o-title-numeric" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "o-title-numeric__num",
    "data-content": "2"
  }),
  /*#__PURE__*/_createTextVNode(" Calcul ")
], -1 /* HOISTED */)
const _hoisted_51 = { class: "o-box__item" }
const _hoisted_52 = { class: "o-table -table-calculator" }
const _hoisted_53 = { class: "tableauResultat" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", { class: "tableauResultat" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Droits de scolarité")
], -1 /* HOISTED */)
const _hoisted_55 = {
  class: "resultat",
  id: "idDroitsScolarite"
}
const _hoisted_56 = { class: "tableauResultat" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", { class: "tableauResultat" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Montant forfaitaire additionnel")
], -1 /* HOISTED */)
const _hoisted_58 = {
  class: "resultat",
  id: "idForfaitaireAdditionnel"
}
const _hoisted_59 = { class: "tableauResultat" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", { class: "tableauResultat" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Bourse de stage")
], -1 /* HOISTED */)
const _hoisted_61 = {
  class: "resultat",
  id: "idBourseStage"
}
const _hoisted_62 = { class: "tableauResultat" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", { class: "tableauResultat" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Assurance maladie et hospitalisation")
], -1 /* HOISTED */)
const _hoisted_64 = {
  class: "resultat",
  id: "idAssuranceMaladie"
}
const _hoisted_65 = { class: "tableauResultat" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", { class: "tableauResultat" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Autres frais institutionnels")
], -1 /* HOISTED */)
const _hoisted_67 = {
  class: "resultat",
  id: "idTotalAutresFrais"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("tr", { class: "tableauResultat" }, [
  /*#__PURE__*/_createElementVNode("td", { class: "tableauResultat" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "" })
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "resultat" })
], -1 /* HOISTED */)
const _hoisted_69 = { class: "tableauResultat" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { class: "tableauResultat" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "Total" }, "Total"),
  /*#__PURE__*/_createTextVNode("  "),
  /*#__PURE__*/_createElementVNode("button", {
    class: "o-button-warning",
    onclick: "document.querySelector('.js-avertissement-calculateur .c-accordion__button').click()"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "warning"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#warning" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_71 = { class: "Total" }
const _hoisted_72 = { id: "idTotal" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("h2", { class: "o-title-3 o-title-numeric" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "o-title-numeric__num",
    "data-content": "3"
  }),
  /*#__PURE__*/_createTextVNode(" Messages ")
], -1 /* HOISTED */)
const _hoisted_74 = { class: "o-box__item" }
const _hoisted_75 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("select", {
                      id: "session",
                      class: "o-select",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.vSession) = $event))
                    }, [
                      _hoisted_12,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.CompSessions, (s) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: 's'+s.id,
                          value: s.id
                        }, _toDisplayString(s.label), 9 /* TEXT, PROPS */, _hoisted_13))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, $data.vSession]
                    ]),
                    _hoisted_14
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("select", {
                      id: "statut",
                      class: "o-select",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.vStatut) = $event))
                    }, _hoisted_23, 512 /* NEED_PATCH */), [
                      [_vModelSelect, $data.vStatut]
                    ]),
                    _hoisted_24
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _withDirectives(_createElementVNode("select", {
                      id: "programme",
                      class: "o-select",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.vClassProgramme) = $event))
                    }, [
                      _hoisted_28,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.programmes, (p, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: 'p'+i,
                          value: p.id
                        }, _toDisplayString(p.label), 9 /* TEXT, PROPS */, _hoisted_29))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, $data.vClassProgramme]
                    ]),
                    _hoisted_30
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _withDirectives(_createElementVNode("select", {
                      id: "activite",
                      class: "o-select",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.vActivite) = $event))
                    }, [
                      _hoisted_34,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.CompActivites, (a, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: 'va'+i,
                          value: a.id
                        }, _toDisplayString(a.label), 9 /* TEXT, PROPS */, _hoisted_35))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, $data.vActivite]
                    ]),
                    _hoisted_36
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _withDirectives(_createElementVNode("select", {
                      id: "credits",
                      class: "o-select",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.vCredits) = $event))
                    }, [
                      _hoisted_40,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.CompCredits, (c) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: 'vc'+c,
                          value: c
                        }, _toDisplayString(c), 9 /* TEXT, PROPS */, _hoisted_41))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, $data.vCredits]
                    ]),
                    _hoisted_42
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("button", {
                    class: "o-button -calculator-submit -button-bg -block",
                    onClick: _cache[5] || (_cache[5] = (...args) => ($options.actionCalculTotal && $options.actionCalculTotal(...args)))
                  }, _hoisted_46)
                ])
              ]),
              ($data.errorMessage !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("h4", _hoisted_49, _toDisplayString($data.errorMessage), 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _hoisted_50,
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("table", null, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("td", _hoisted_55, _toDisplayString($data.DroitsScolarite), 1 /* TEXT */)
                  ]),
                  _createElementVNode("tr", _hoisted_56, [
                    _hoisted_57,
                    _createElementVNode("td", _hoisted_58, _toDisplayString($data.ForfaitaireAdditionnel), 1 /* TEXT */)
                  ]),
                  _createElementVNode("tr", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("td", _hoisted_61, _toDisplayString($data.BourseStage), 1 /* TEXT */)
                  ]),
                  _createElementVNode("tr", _hoisted_62, [
                    _hoisted_63,
                    _createElementVNode("td", _hoisted_64, _toDisplayString($data.AssuranceEtranger), 1 /* TEXT */)
                  ]),
                  _createElementVNode("tr", _hoisted_65, [
                    _hoisted_66,
                    _createElementVNode("td", _hoisted_67, _toDisplayString($data.TotalAutresFrais), 1 /* TEXT */)
                  ]),
                  _hoisted_68
                ]),
                _createElementVNode("tfoot", null, [
                  _createElementVNode("tr", _hoisted_69, [
                    _hoisted_70,
                    _createElementVNode("td", _hoisted_71, [
                      _createElementVNode("span", _hoisted_72, _toDisplayString($data.Total), 1 /* TEXT */)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_73,
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", {
              class: "o-text",
              innerHTML: $options.CompMessages
            }, null, 8 /* PROPS */, _hoisted_75)
          ])
        ])
      ])
    ])
  ]))
}